// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"pendingPackage_pageWrapper__2xTnO"};